module.exports = __webpack_public_path__ + "static/undraw_version_control_v2-0f7ddefae71bf20ad33afecc6d81895f.svg";